import type { FieldPath, FieldValues } from "react-hook-form";
import type { TextInputProps } from "./TextInput";
import { TextInput } from "./TextInput";

export function EmailInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Omit<TextInputProps<TFieldValues, TName>, "type" | "autoComplete">) {
  return (
    <TextInput
      {...(props as TextInputProps<TFieldValues, TName>)}
      type="email"
      autoComplete="email"
    />
  );
}
